import { UserRole } from '@treetop/shared/model';

const viewComponents = 'viewComponents';
const viewGuidelines = 'viewGuidelines';
const addComponent = 'addComponent';
const editComponent = 'editComponent';
// Component
const setInProgressComponent = 'setInProgressComponent';
const requestApprovalComponent = 'requestApprovalComponent';
const approveComponent = 'approveComponent';
const publishComponent = 'publishComponent';
const deactivateComponent = 'deactivateComponent';
const deactivatePublishedComponent = 'deactivatePublishedComponent';
const reactivateComponent = 'reactivateComponent';
const proposeComponent = 'proposeComponent';
const viewUsersOfComponent = 'viewUsersOfComponent';
const filterOrganisationComponent = 'filterOrganisationComponent';
const removeComponent = 'removeComponent';
//CodeableConcept
const viewCodeableConcept = 'viewCodeableConcept';
const addCodeableConcept = 'addCodeableConcept';
const editCodeableConcept = 'editCodeableConcept';
const removeCodeableConcept = 'removeCodeableConcept';

// Guideline
const editGuideline = 'editGuideline';
const addGuideline = 'addGuideline';
const editAllGuidelines = 'editAllGuidelines';

const requestApprovalGuidelineWithConfirmation = 'requestApprovalGuidelineWithConfirmation';

const setInReviewGuideline = 'setInReviewGuideline';
const approveGuideline = 'approveGuideline';

const publishGuideline = 'publishGuideline';
const publishGuidelineWithConfirmation = 'publishGuidelineWithConfirmation';

const setInProgressGuidelineFromInactiveWithConfirmation = 'setInProgressGuidelineFromInactiveWithConfirmation';
const setInProgressGuidelineFromReadyWithConfirmation = 'setInProgressGuidelineFromReadyWithConfirmation';

const deactivateInProgressGuidelineWithConfirmation = 'deactivateInProgressGuidelineWithConfirmation';
const deactivateReadyGuidelineWithConfirmation = 'deactivateReadyGuidelineWithConfirmation';
const deactivatePublishedGuidelineWithConfirmation = 'deactivatePublishedGuidelineWithConfirmation';
const deactivateGuideline = 'deactivateGuideline';

const filterOrganisationGuideline = 'filterOrganisationGuideline';
const removeGuideline = 'removeGuideline';
// SmartBook
const viewSmartBook = 'viewSmartBook';
// PlanDefinition
const viewPlanDefinitions = 'viewPlanDefinitions';
// AssetManagement
const viewAssetManagement = 'viewAssetManagement';
const modifyAssets = 'modifyAssets';
// Literature management
const viewLiteratureManagement = 'viewLiteratureManagement';
const modifyLiterature = 'modifyLiterature';
// Guideline Cluster
const readOrganisationsAvailableForSharing = 'readOrganisationsAvailableForSharing';
const viewGuidelineClusters = 'viewGuidelineClusters';
const createGuidelineClusters = 'createGuidelineClusters';
const acceptGuidelineClusters = 'acceptGuidelineClusters';
const denyGuidelineClusters = 'denyGuidelineClusters';
const removeGuidelineClusters = 'removeGuidelineClusters';
//Tag
const viewTag = 'viewTag';
const addTag = 'addTag';
const editTag = 'editTag';
const removeTag = 'removeTag';
const viewGuidelineUsers = 'viewGuidelineUsers';
//New pages
const viewDashboardPage = 'viewDashboardPage'; // Added to differentiate old smartbook and new dashboard temporarily. Smartbook still used by Treetop Users.
const viewManagePage = 'viewManagePage';
const viewSharePage = 'viewSharePage';
const viewStatistics = 'viewStatistics';
const editTaxonomy = 'editTaxonomy';
const copyGuidelines = 'copyGuidelines';
const viewAllOrganisationStatistics = 'viewAllOrganisationStatistics';
// Hub permissions
const syncWithHub = 'syncWithHub';
//General
const editOrganisationSettings = 'editOrganisationSettings';
const viewReviewPage = 'viewReviewPage';
// Pdf Export
const exportPdf = 'exportPdf';
const viewGuidelineEditing = 'viewGuidelineEditing';

export const RolePermissions = {
  viewComponents,
  addComponent,
  editComponent,
  viewCodeableConcept,
  addCodeableConcept,
  editCodeableConcept,
  setInProgressComponent,
  requestApprovalComponent,
  approveComponent,
  publishComponent,
  deactivateComponent,
  deactivatePublishedComponent,
  reactivateComponent,
  proposeComponent,
  viewUsersOfComponent,
  filterOrganisationComponent,
  viewGuidelines,
  setInProgressGuidelineFromInactiveWithConfirmation,
  setInProgressGuidelineFromReadyWithConfirmation,
  requestApprovalGuidelineWithConfirmation,
  approveGuideline,
  setInReviewGuideline,
  publishGuideline,
  publishGuidelineWithConfirmation,
  deactivateInProgressGuidelineWithConfirmation,
  deactivateReadyGuidelineWithConfirmation,
  deactivatePublishedGuidelineWithConfirmation,
  viewSmartBook,
  editGuideline,
  editAllGuidelines,
  filterOrganisationGuideline,
  viewPlanDefinitions,
  viewAssetManagement,
  modifyAssets,
  viewLiteratureManagement,
  modifyLiterature,
  removeGuideline,
  removeComponent,
  removeCodeableConcept,
  readOrganisationsAvailableForSharing,
  viewGuidelineClusters,
  createGuidelineClusters,
  acceptGuidelineClusters,
  denyGuidelineClusters,
  removeGuidelineClusters,
  viewTag,
  addTag,
  editTag,
  removeTag,
  viewDashboardPage,
  viewManagePage,
  viewSharePage,
  viewStatistics,
  editTaxonomy,
  copyGuidelines,
  viewAllOrganisationStatistics,
  syncWithHub,
  editOrganisationSettings,
  viewReviewPage,
  exportPdf,
  viewGuidelineEditing,
};

export function getRolePermissions(role: UserRole): string[] {
  switch (role) {
    case UserRole.TreetopAdmin:
      return [
        viewGuidelineUsers,
        viewComponents,
        addComponent,
        editComponent,
        viewCodeableConcept,
        addCodeableConcept,
        editCodeableConcept,
        requestApprovalComponent,
        setInProgressComponent,
        deactivateComponent,
        deactivatePublishedComponent,
        reactivateComponent,
        viewUsersOfComponent,
        filterOrganisationComponent,
        viewGuidelines,
        filterOrganisationGuideline,
        viewLiteratureManagement,
        modifyLiterature,
        removeComponent,
        removeCodeableConcept,
        viewTag,
        addTag,
        editTag,
        removeTag,
        editTaxonomy,
        copyGuidelines,
        viewAllOrganisationStatistics,
      ];
    case UserRole.TreetopAnalytics:
      return [];
    case UserRole.TreetopMedicalExpert:
      return [
        viewGuidelineUsers,
        viewComponents,
        addComponent,
        editComponent,
        viewCodeableConcept,
        addCodeableConcept,
        editCodeableConcept,
        requestApprovalComponent,
        setInProgressComponent,
        deactivateComponent,
        reactivateComponent,
        viewUsersOfComponent,
        filterOrganisationComponent,
        viewLiteratureManagement,
        modifyLiterature,
        removeComponent,
        removeCodeableConcept,
        viewTag,
        addTag,
        editTag,
        removeTag,
      ];
    case UserRole.TreetopSeniorMedicalExpert:
      return [
        viewGuidelineUsers,
        viewComponents,
        addComponent,
        editComponent,
        viewCodeableConcept,
        addCodeableConcept,
        editCodeableConcept,
        requestApprovalComponent,
        setInProgressComponent,
        approveComponent,
        publishComponent,
        deactivateComponent,
        deactivatePublishedComponent,
        reactivateComponent,
        viewUsersOfComponent,
        filterOrganisationComponent,
        viewSmartBook,
        filterOrganisationGuideline,
        viewGuidelines,
        viewLiteratureManagement,
        modifyLiterature,
        removeComponent,
        removeCodeableConcept,
        viewTag,
        addTag,
        editTag,
        removeTag,
        exportPdf,
      ];
    case UserRole.ContentPartnerOrganisationAdmin:
      return [];
    case UserRole.ContentPartnerMedicalExpert:
      return [
        viewComponents,
        editComponent,
        viewCodeableConcept,
        editCodeableConcept,
        requestApprovalComponent,
        setInProgressComponent,
        proposeComponent,
      ];
    case UserRole.ContentPartnerSeniorMedicalExpert:
      return [
        viewComponents,
        editComponent,
        viewCodeableConcept,
        editCodeableConcept,
        requestApprovalComponent,
        setInProgressComponent,
        proposeComponent,
      ];
    case UserRole.ClinicalPartnersOrganisationAdmin:
      return [
        readOrganisationsAvailableForSharing,
        viewGuidelineClusters,
        createGuidelineClusters,
        acceptGuidelineClusters,
        denyGuidelineClusters,
        removeGuidelineClusters,
        viewDashboardPage,
        viewSharePage,
        viewStatistics,
        editTaxonomy,
        syncWithHub,
        editOrganisationSettings,
      ];
    case UserRole.ClinicalPartnersClinician:
      return [viewDashboardPage];
    case UserRole.ClinicalPartnersSeniorClinician:
      return [
        editAllGuidelines,
        viewCodeableConcept,
        proposeComponent,
        approveGuideline,
        setInReviewGuideline,
        publishGuideline,
        deactivateGuideline,
        editGuideline,
        modifyAssets,
        modifyLiterature,
        removeGuideline,
        viewDashboardPage,
        viewManagePage,
        addGuideline,
        viewStatistics,
        exportPdf,
        viewGuidelineEditing,
      ];

    case UserRole.Reviewer:
      return [viewReviewPage, viewGuidelineEditing];
    case UserRole.ClinicalPartnersEditorClinician:
      return [
        viewCodeableConcept,
        proposeComponent,
        modifyAssets,
        modifyLiterature,
        viewDashboardPage,
        viewManagePage,
        editGuideline,
        addGuideline,
        viewStatistics,
        viewGuidelineEditing,
      ];
    case UserRole.TemporaryEditor:
      return [editGuideline, viewGuidelineEditing];
    default:
      return [];
  }
}
